import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components';

function NotFound() {
  const navigate = useNavigate();

  const funnyMessages = [
    "Looks like this query returned null...",
    "Error: Path.NotFound - Even Table.SelectRows couldn't find this!",
    "This page went through List.RemoveItems and never came back.",
    "404: Record.Field failed - field 'page' not found in record.",
    "Oops! This URL failed type validation.",
    "try navigate(\"/\") otherwise error \"Page not found\"",
    "Expression.Evaluate failed: undefined route",
    "This page is more elusive than a null in a left join.",
  ];

  const randomMessage = funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  const codeSnippet = `let
    requestedPage = "${window.location.pathname}",
    result = Table.SelectRows(
        AllPages,
        each [Path] = requestedPage
    )
in
    if Table.IsEmpty(result) then
        error "404: Page not found"
    else
        result`;

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="p-4 border-b border-[#2a2d31]">
        <div className="max-w-6xl mx-auto flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-game-primary to-game-teal-dark flex items-center justify-center">
            <span className="text-white font-bold text-lg">M</span>
          </div>
          <h1 className="text-2xl font-bold text-game-text">
            M-Quest
          </h1>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="max-w-4xl w-full text-center animate-fade-in">
          {/* Big 404 */}
          <div className="mb-6">
            <span className="text-9xl font-bold bg-gradient-to-r from-game-primary to-game-teal-dark bg-clip-text text-transparent">
              404
            </span>
          </div>

          {/* Funny M-language themed message */}
          <h2 className="text-2xl md:text-3xl font-bold text-game-text mb-6">
            {randomMessage}
          </h2>

          {/* Code snippet showing the "error" */}
          <div className="bg-game-surface rounded-2xl p-5 mb-8 text-left font-mono text-sm overflow-x-auto border border-[#2a2d31]">
            <div className="text-game-text-dim mb-2">// What happened:</div>
            <pre className="text-[#C2A528] whitespace-pre-wrap">{codeSnippet}</pre>
            <div className="text-red-400 mt-3">
              [Error] Expression.Error: Page "{window.location.pathname}" was not found.
            </div>
          </div>

          {/* Fun ASCII art */}
          <div className="text-game-text-dim font-mono text-xs mb-8 hidden md:block">
            <pre>{`
    ╔══════════════════════════════════╗
    ║   Power Query couldn't find it   ║
    ║   Maybe try the homepage? ;)     ║
    ╚══════════════════════════════════╝
            `}</pre>
          </div>

          {/* Navigation buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              size="lg"
            >
              <Home size={20} className="mr-2" />
              Go to Homepage
            </Button>
            <Button
              onClick={() => navigate(-1)}
              variant="secondary"
              size="lg"
            >
              <ArrowLeft size={20} className="mr-2" />
              Go Back
            </Button>
          </div>

          {/* Easter egg hint */}
          <p className="text-game-text-dim mt-8 text-sm">
            Hint: All valid routes are in the <code className="text-game-accent">#shared</code> environment
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="p-6 text-center text-sm text-game-text-dim border-t border-[#2a2d31]">
        Learn M Language (Power Query) • <a href="https://datameerkat.com" target="_blank" rel="noopener noreferrer" className="hover:text-game-text transition-colors">DataMeerkat</a>
      </footer>
    </div>
  );
}

export default NotFound;
